import { Typography, capitalize, styled } from "@mui/material";
import { actionHeaderName } from "../classes.js";
const Subtitle = styled(Typography, {
  name: actionHeaderName,
  slot: "Subtitle",
  shouldForwardProp: (prop) => prop !== "ownerState",
  overridesResolver: (props, styles) => {
    const { ownerState } = props;
    return [styles.subtitle, ownerState?.size && styles[`subtitleSize${capitalize(ownerState.size)}`]];
  }
})(({ theme }) => ({
  fontSize: "inherit",
  userSelect: "none",
  marginRight: theme.spacing(0.5)
}));
export {
  Subtitle
};
//# sourceMappingURL=Subtitle.js.map
